export enum ELayoutActions {
    SET_FOOTER_VISIBILITY = 'SET_FOOTER_VISIBILITY',
    SET_HEADER_COLOR = 'SET_HEADER_COLOR',
}
